import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical } from "lucide-react";
import styles from "./SortableRow.module.css";

interface Props {
    id: string | number;
    children: React.ReactNode;
    variant?: "default" | "dense";
}

const SortableRow: React.FC<Props> = ({ id, children, variant = "default" }) => {

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.7 : 1
    };

    return (
        <div ref={setNodeRef} style={style} className={`${styles.row} ${styles[variant]}`}>

            <div {...attributes} {...listeners} className={styles.handle}>
                <GripVertical size={18}/>
            </div>

            <div className={styles.content}>
                {children}
            </div>

        </div>
    );
};

export default SortableRow;